import { hopperAddHeadroom } from './hopperCapacity';

export const CLUB_FILL_STEP = 50;
export const CLUB_FILL_TOAST = 'FILL LOGGED';
export const CLUB_REMOVE_TOAST = 'FEED REMOVED';
export const CLUB_FILL_NOTE_MAX = 200;
export const CLUB_FILL_STEP_UNBOUNDED = 9999;

export const CLUB_FEED_TYPES = [
  'Corn',
  'Protein Pellets',
  'Rice Bran',
  'Corn/Soybean Mix',
  'Corn/Protein Mix',
  'Deer Draw',
  'Triple Grip',
  'Rack Attack',
  'Other Premium Blend',
].map((label) => ({ label, value: label.toLowerCase() }));

export function clubFillDefaultAmount(headroom) {
  if (headroom == null) return CLUB_FILL_STEP;
  return Math.min(CLUB_FILL_STEP, Math.max(0, headroom));
}

export function clubFillStepCap({ removing = false, headroom = null, remainingLbs = null } = {}) {
  if (removing) {
    if (remainingLbs == null || remainingLbs === '') return CLUB_FILL_STEP_UNBOUNDED;
    const have = Number(remainingLbs);
    return Number.isFinite(have) ? Math.max(0, Math.round(have)) : CLUB_FILL_STEP_UNBOUNDED;
  }
  if (headroom == null) return CLUB_FILL_STEP_UNBOUNDED;
  return Math.max(0, headroom);
}

export function clubFillAmountAfterStep(current, delta, headroom) {
  const max = headroom == null ? CLUB_FILL_STEP_UNBOUNDED : Math.max(0, headroom);
  return Math.max(0, Math.min(max, current + delta));
}

export function clubFillSignedAmount(magnitude, removing) {
  const mag = Math.max(0, Math.round(Number(magnitude) || 0));
  if (mag === 0) return 0;
  return removing ? -mag : mag;
}

export function clubFillLoggedToast(amountLbs) {
  return Number(amountLbs) < 0 ? CLUB_REMOVE_TOAST : CLUB_FILL_TOAST;
}

export function clubFeedNotifyLine(memberCount, removing = false) {
  if (removing) {
    return 'Corrections skip the refill notice. Everyone still gets a low/empty alert if this crosses.';
  }
  const n = Math.max(0, Math.round(Number(memberCount) || 0));
  const who = n === 1 ? 'All 1 member gets' : `All ${n} members get`;
  return `${who} a refill notice. Everyone also gets a low/empty alert if the hopper crosses.`;
}

export function clubFillCtaLabel(name, removing = false, personal = false) {
  if (personal) return removing ? 'REMOVE FEED' : 'LOG FILL';
  const who = String(name || '').trim().toUpperCase() || 'YOU';
  return removing ? `REMOVE FEED AS ${who}` : `LOG FILL AS ${who}`;
}

export function clubFillHopperCaption(capacityLbs, headroom) {
  if (capacityLbs == null || headroom == null) return null;
  return `HOPPER HOLDS ${Math.round(capacityLbs)} LB · ${headroom} LB OF SPACE LEFT`;
}

export function defaultClubLogFeedType(station) {
  const raw = String(station?.default_feed_type || '').trim().toLowerCase();
  if (CLUB_FEED_TYPES.some((option) => option.value === raw)) return raw;
  return CLUB_FEED_TYPES[0].value;
}

export function clubLogFillMemberName(user, getDisplayName) {
  const name = typeof getDisplayName === 'function' ? getDisplayName(user) : '';
  if (!name || name === 'Unknown User') return '';
  return name;
}

export function clubFillCanLog(station) {
  return Boolean(station) && station.feeding_is_active !== false;
}

export function clubFillHeadroom(station) {
  return hopperAddHeadroom(station?.feed_capacity_lbs, station?.estimated_remaining_lbs);
}
